export default "__VITE_ASSET__BhfONHW2__"